import React from 'react'

import ReplyValueCondition from './ReplyValueCondition'

const CustomCondition = ({ children, ...props }) => {
  switch (props.condition?.field) {
    case '_event_service_order_reply_value':
    case '_form_reply_reply_value':
      return <ReplyValueCondition {...props} />
    default:
      return children
  }
}

export default CustomCondition
